<script setup>
import { ref, computed } from 'vue'
import { store } from '@/store/appStore.js'

const search = ref('')
const items = store.warehouseV2.inventory
const filtered = computed(() => {
  const q = search.value.trim().toLowerCase()
  return items.filter(i => !q || i.productName.toLowerCase().includes(q) || i.productSku.toLowerCase().includes(q) || i.batchNo.toLowerCase().includes(q))
})
</script>

<template>
  <div>
    <div class="card module-header"><h2>{{ store.warehouseV2.warehouseName }} — Inventory</h2></div>
    <div class="card">
      <div class="toolbar">
        <input class="search-input" v-model="search" placeholder="Search product, SKU or batch no.…" />
        <span class="result-count">{{ filtered.length }} of {{ items.length }} shown</span>
      </div>
      <div class="table-wrap">
        <table class="data-table">
          <thead><tr><th>Product</th><th>Brand</th><th>Batch No.</th><th>Mfg Date</th><th>Expiry Date</th><th>Available Qty</th></tr></thead>
          <tbody>
            <tr v-for="i in filtered" :key="i.productSku">
              <td class="cell-strong">{{ i.productName }}</td><td class="cell-muted">{{ i.brandName }}</td>
              <td class="cell-muted">{{ i.batchNo }}</td><td class="cell-muted">{{ i.mfgDate }}</td><td class="cell-muted">{{ i.expiryDate }}</td>
              <td class="cell-strong">{{ i.availableQty }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
